module.exports = __webpack_public_path__ + "media/images/ross-parmly-rf6ywHVkrlY-unsplash-103042e2031805d58cf064110be4ffbb.jpg";